var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useState, useEffect } from "react";
import { useTheme } from "../ThemeProvider/ThemeProvider";
import styled from "styled-components";
var getSize = function (size) {
    switch (size) {
        case "small":
            return {
                height: "0.6rem",
                width: "1rem",
                contentSize: "0.4rem",
                top: "0.1rem",
                unselectedLeft: "0.1rem",
                selectedLeft: "0.5rem",
                padding: "0.2rem",
            };
        case "medium":
            return {
                height: "0.8rem",
                width: "1.4rem",
                contentSize: "0.6rem",
                top: "0.1rem",
                unselectedLeft: "0.1rem",
                selectedLeft: "0.7rem",
                padding: "0.3rem",
            };
        case "large":
            return {
                height: "1rem",
                width: "1.8rem",
                contentSize: "0.8rem",
                top: "0.1rem",
                unselectedLeft: "0.1rem",
                selectedLeft: "0.9rem",
                padding: "0.5rem",
            };
    }
};
var StyledSwitch = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  cursor: pointer;\n  padding: ", ";\n  border-radius: 1rem;\n  & input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  cursor: pointer;\n  padding: ", ";\n  border-radius: 1rem;\n  & input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n  }\n"])), function (props) { return getSize(props.$size).padding; });
var StyledSwitchContent = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 1rem;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n\n  & span {\n    top: ", ";\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    background-color: ", ";\n    transition: left 0.2s ease-in-out;\n  }\n\n  & .ste-switch-content-unselected {\n    left: ", ";\n  }\n  & .ste-switch-content-selected {\n    left: ", ";\n  }\n"], ["\n  position: relative;\n  border-radius: 1rem;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n\n  & span {\n    top: ", ";\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    background-color: ", ";\n    transition: left 0.2s ease-in-out;\n  }\n\n  & .ste-switch-content-unselected {\n    left: ", ";\n  }\n  & .ste-switch-content-selected {\n    left: ", ";\n  }\n"])), function (props) { return getSize(props.$size).width; }, function (props) { return getSize(props.$size).height; }, function (props) {
    return props.$checked
        ? props.$colorGradient[props.$color].accentScale[8]
        : props.$colorGradient[props.$color].grayScale[8];
}, function (props) { return getSize(props.$size).top; }, function (props) { return getSize(props.$size).contentSize; }, function (props) { return getSize(props.$size).contentSize; }, function (props) { return "#ffffff"; }, function (props) { return getSize(props.$size).unselectedLeft; }, function (props) { return getSize(props.$size).selectedLeft; });
var Switch = forwardRef(function (_a, ref) {
    var id = _a.id, value = _a.value, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.checked, checked = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, label = _a.label, name = _a.name, className = _a.className, style = _a.style, 
    // Events
    onChange = _a.onChange, props = __rest(_a, ["id", "value", "size", "color", "checked", "disabled", "label", "name", "className", "style", "onChange"]);
    var innerRef = React.useRef(null);
    var _ref = (ref !== null && ref !== void 0 ? ref : innerRef);
    var _f = useState(checked !== null && checked !== void 0 ? checked : false), isChecked = _f[0], setIsChecked = _f[1];
    var colorPalette = useTheme().theme.colorPalette;
    useEffect(function () {
        setIsChecked(checked !== null && checked !== void 0 ? checked : false);
    }, [checked]);
    var _onChange = function (event) {
        setIsChecked(function (prev) {
            return !prev;
        });
        onChange && onChange(event);
    };
    return (_jsxs(StyledSwitch, __assign({ role: "switch", "aria-checked": isChecked, className: className, "$checked": isChecked, "$disabled": disabled, "$size": size, "$color": color, "$colorGradient": colorPalette }, props, { children: [_jsx("input", { ref: _ref, type: "checkbox", checked: isChecked, name: name, onChange: _onChange }), _jsx(StyledSwitchContent, __assign({ "$checked": isChecked, "$disabled": disabled, "$size": size, "$color": color, "$colorGradient": colorPalette }, { children: _jsx("span", { className: "".concat(isChecked ? "ste-switch-content-selected" : "ste-switch-content-unselected") }) }))] })));
});
export default Switch;
var templateObject_1, templateObject_2;
